// ----------------------------------------------------------------------------
// Snippet: Menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_menu.scss';
import './_menu--dropdown.scss';

// -------------------------------------
// Hooks
// -------------------------------------
function closeMenus() {
    // close menu
    document.querySelectorAll('.header .menu__item--dropdown.js--isOpen').forEach(item => {
        item.classList.remove('js--isOpen');
        item.querySelector('.menu__link').setAttribute('aria-expanded', 'false');
    });
}
$(function() {

    let timeoutID;
    function hoverMenu() {
        if (window.innerWidth >= 1024) {
            $('.header .menu__item--dropdown:not(.js--bound)').addClass('js--bound').on('mouseenter mouseleave', allowHoverOnMenu)
        } else {
            $('.header .menu__item--dropdown.js--bound').removeClass('js--bound').off('mouseenter mouseleave', allowHoverOnMenu)
        }
    }
    function allowHoverOnMenu(e) {

        e.preventDefault();
        if (e.type === 'mouseenter') {
            clearTimeout(timeoutID);
            closeMenus();
            $(e.currentTarget).addClass('js--isOpen');
            $(e.currentTarget).find('.menu__link').attr('aria-expanded', 'true');
        }
        if (e.type === 'mouseleave') {
            timeoutID = setTimeout(function(event){
                $(e.currentTarget).removeClass('js--isOpen');
                $(e.currentTarget).find('.menu__link').attr('aria-expanded', 'false');
            }, 250);

        }
    }
    // Opens dropdowns
        $('.header .menu__item--dropdown .menu__link').on('click', function(e) {
            // Store elements as an object

            var $dropdown = $(this).closest('.menu__item--dropdown');

            if ($dropdown.siblings().hasClass('js--isOpen')) {
                $dropdown.siblings().removeClass('js--isOpen');
                $dropdown.siblings().find('.menu__link').attr('aria-expanded', 'false');
                $dropdown.addClass('js--isOpen');
                $dropdown.find('.menu__link').attr('aria-expanded', 'true');
            } else {
                $dropdown.toggleClass('js--isOpen');
                $dropdown.find('.menu__link').attr('aria-expanded', (_, attr) => attr == 'true' ? 'false' : 'true');
            }

        });




        hoverMenu();
        $(window).on('resize', hoverMenu);


    $('.header .menu__item--dropdown').on('focusout', function(event) {
        // If focus is still in the form, do nothing
        if (this.contains(event.relatedTarget)) return;

        // Otherwise, log a message
        closeMenus();
    });

    $('.header .menu__item--dropdown').on('focusout', function(event) {
        // If focus is still in the form, do nothing
        if (this.contains(event.relatedTarget)) return;

        // Otherwise, log a message
        closeMenus();
    });

    $('.header .menu__item--dropdown').on('keyup', function(e) {
        // Listens for Escape Key
        if (e.key == 'Escape' ) {
            closeMenus();
            e.currentTarget.querySelector('.menu__link').focus();
        }
    });

});
